import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { ClientRegisteredVendor } from './client-registered-vendor';
import { ExemptVendor } from './exempt-vendor';
import { Vendor } from './vendor';

export class SiteVendor extends BaseModel {
  static SiteVendorProperties: (
    | {
        property: keyof SiteVendor;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof SiteVendor;
        type: 'alias';
      }
    | {
        property: keyof SiteVendor;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'SiteId', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'ExemptVendorId', type: 'column', dataType: 'number' },
    {
      property: 'ClientRegisteredVendorId',
      type: 'column',
      dataType: 'number'
    },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'vendorLegalName', type: 'alias' },
    { property: 'vendorDba', type: 'alias' },
    { property: 'vendorViveStatus', type: 'alias' },
    { property: 'vendorViveSubStatus', type: 'alias' },
    { property: 'vendorViveStatusDate', type: 'alias' },
    { property: 'vendorStreetCity', type: 'alias' },
    { property: 'vendorStreetState', type: 'alias' },

    { property: 'Vendor', model: 'Vendor', type: 'association' },
    {
      property: 'ClientRegisteredVendor',
      model: 'ClientRegisteredVendor',
      type: 'association'
    },
    { property: 'ExemptVendor', model: 'ExemptVendor', type: 'association' }
  ];

  static {
    SiteVendor.SiteVendorProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        SiteVendor.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        SiteVendor.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        SiteVendor.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(SiteVendorObject: Partial<SiteVendor>) {
    super();

    SiteVendor.SiteVendorProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = SiteVendorObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  SiteId?: number;
  VendorId?: number | null;
  ExemptVendorId?: number | null;
  ClientRegisteredVendorId?: number | null;
  createdAt?: Date;
  updatedAt?: Date;

  vendorLegalName?: string;
  vendorDba?: string;
  vendorViveStatus?: string;
  vendorViveSubStatus?: string;
  vendorViveStatusDate?: Date;
  vendorStreetCity?: string;
  vendorStreetState?: string;

  Vendor?: Vendor;
  ClientRegisteredVendor?: ClientRegisteredVendor;
  ExemptVendor?: ExemptVendor;
}
